import AmountInput from './Index.vue'

AmountInput.install = function(Vue) {
    Vue.component(AmountInput.name, AmountInput)
}

export default AmountInput
